import React from "react";

export default function useCasePageBox() {
  return (
    <div>
      <div className="use-case-page-title">
        <h3>Case Study XYZ</h3>
        <h1>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est aperiam
          eos maxime sunt facere eligendi
        </h1>
      </div>
      <div className="use-case-page-content">
        <div className="use-case-page-content-left">
          <div className="use-case-company-logo">
            <img
              src="https://nwafoundation.org/wp-content/uploads/2017/04/FedEx-Logo-PNG-Transparent.png"
              alt="LOGO"
            />
            <h2>XYZ Company</h2>
          </div>
          <div className="use-case-page-content-left-info">
            <h4>Solution</h4>
            <h5>Flexnet Basic</h5>
          </div>
          <div className="use-case-page-content-left-info">
            <h4>Vertical</h4>
            <h5>XYZ</h5>
          </div>
          <div className="use-case-page-content-left-info">
            <h4>Project KPI</h4>
            <h5>XYZ</h5>
          </div>
          <div className="use-case-page-content-left-info">
            <h4>Core Themes</h4>
            <h5>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rerum
              magnam sapiente architecto, veniam itaque distinctio id quo ab
              beatae excepturi similique quisquam, deserunt animi, est quae
              voluptas magni maiores assumenda?
            </h5>
          </div>
          <div className="use-case-page-content-left-info">
            <h4>Their Story</h4>
            <h5>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rerum
              magnam sapiente architecto, veniam itaque distinctio id quo ab
              beatae excepturi similique quisquam, deserunt animi, est quae
              voluptas magni maiores assumenda?
            </h5>
          </div>
        </div>
        <div className="use-case-page-content-right">
          <div className="project-right-top">
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Non,
              facilis deserunt aliquam quibusdam, at, vitae accusantium pariatur
              totam officia eius veritatis quas voluptate perferendis maiores.
              Deleniti qui vitae totam harum. Lorem ipsum, dolor sit amet
              consectetur adipisicing elit. Non, facilis deserunt aliquam
              quibusdam, at, vitae accusantium pariatur totam officia eius
              veritatis quas voluptate perferendis maiores. Deleniti qui vitae
              totam harum. Lorem ipsum, dolor sit amet consectetur adipisicing
              elit. Non, facilis deserunt aliquam quibusdam, at, vitae
              accusantium pariatur totam officia eius veritatis quas voluptate
              perferendis maiores. Deleniti qui vitae totam harum.Lorem ipsum,
              dolor sit amet consectetur adipisicing elit. Non, facilis deserunt
              aliquam quibusdam, at, vitae accusantium pariatur totam officia
              eius veritatis quas voluptate perferendis maiores. Deleniti qui
              vitae totam harum.
            </p>
          </div>

          <div className="project-overview">
            <h1>Overview</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae
              optio ea omnis tempora ab officiis magnam expedita inventore animi
              ratione aut, doloribus consequatur consequuntur earum harum
              obcaecati necessitatibus sapiente nobis! Lorem ipsum dolor sit
              amet consectetur adipisicing elit. Molestiae optio ea omnis
              tempora ab officiis magnam expedita inventore animi ratione aut,
              doloribus consequatur consequuntur earum harum obcaecati
              necessitatibus sapiente nobis!
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Error
              vitae voluptatibus id quasi modi repellendus doloremque quas earum
              tenetur cumque eos animi labore, omnis dolor velit accusantium
              obcaecati odit commodi.
            </p>
          </div>
          <div className="project-results">
            <h1>Results</h1>

            <div className="project-results-text">
              <h1>xyz</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Voluptas tenetur asperiores enim, eum ipsa in animi et
                architecto illum quos doloribus minima laboriosam quidem aperiam
                illo hic deleniti accusamus accusantium.
              </p>
            </div>

            <div className="project-results-text">
              <h1>xyz</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Voluptas tenetur asperiores enim, eum ipsa in animi et
                architecto illum quos doloribus minima laboriosam quidem aperiam
                illo hic deleniti accusamus accusantium.
              </p>
            </div>

            <div className="project-circle-result-parent">
              <div className="project-circle-result-parent-container">
                <div className="project-circle-result">
                  <span>10%</span>
                </div>
                <span>xyz gain</span>
              </div>
              <div className="project-circle-result-parent-container">
                <div className="project-circle-result">
                  <span>10%</span>
                </div>
                <span>xyz gain</span>
              </div>
              <div className="project-circle-result-parent-container">
                <div className="project-circle-result">
                  <span>10%</span>
                </div>
                <span>xyz gain</span>
              </div>
            </div>

            <div className="project-results-text">
              <h1>xyz</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Voluptas tenetur asperiores enim, eum ipsa in animi et
                architecto illum quos doloribus minima laboriosam quidem aperiam
                illo hic deleniti accusamus accusantium.
              </p>
            </div>

            <div className="project-results-text">
              <h1>xyz</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Voluptas tenetur asperiores enim, eum ipsa in animi et
                architecto illum quos doloribus minima laboriosam quidem aperiam
                illo hic deleniti accusamus accusantium.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
